/*This is will be the form for creating and acocunt i want this to be a formt hta a admin can use to help other screate and acocutn (ie it will genetaret a temporty password that a user has to update on first login) or that a user cna use themesefls to create and accoutna dn they can shouces there own password*/
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import AccountSetupStepper from "../components/AccountSetupStepper";
import AccountDetailsStep from "../components/steps/AccountDetailsStep";
import TermsStep from "../components/steps/TermsStep";
import AccountCompletionStep from "../components/steps/AccountCompletionStep";
import config from "../config";
import './CreateAccount.css';
const baseUrl = config.apiBaseUrl;

const CreateAccount = () => {
    const location = useLocation();
    const navigate = useNavigate();
    


    // Step management
    const [currentStep, setCurrentStep] = useState(0);
    const steps = ['Account Details', 'Terms & Conditions', 'Complete Setup'];
    
    // Form data
    const [venueKey, setVenueKey] = useState('');
    const [oiriginTrace, setOiriginTrace] = useState('');
    const [userId, setUserId] = useState(''); // Store user ID after account creation
    const [userAlreadyExists, setUserAlreadyExists] = useState(false); // Track if user already exists
    const [formData, setFormData] = useState({
        email: '',
        firstName: '',
        surname: '',
        password: '',
        confirmPassword: ''
    });
    
    // Validation and state
    const [emailValidationText, setEmailValidationText] = useState('');
    const [passwordValidationText, setPasswordValidationText] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    
    // Terms acceptance
    const [worldHighStreetTermsAccepted, setWorldHighStreetTermsAccepted] = useState(false);
    const [venueTermsAccepted, setVenueTermsAccepted] = useState(false); // Will store hash when accepted
    




    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const key = params.get('venue-key');
        const keyOriginKey = params.get('ogt');

        
        if (key) {
            setVenueKey(key);
        }
        if(keyOriginKey){
            setOiriginTrace(keyOriginKey);
        }
        

    }, [location]);



    // Form validation functions
    function resetValidationText() {
        setEmailValidationText('');
        setPasswordValidationText('');
    }

    function validateStep1() {
        resetValidationText();
        let emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
        
        if (!emailPattern.test(formData.email)) {
            setEmailValidationText('Please enter a valid email address');
            return false;
        }

        if (!matchValue(formData.password, formData.confirmPassword)) {
            setPasswordValidationText('Passwords do not match');
            return false;
        }

        if(formData.password.length < 8){
            setPasswordValidationText('Password must be at least 8 characters');
            return false;
        }

        return true;
    }

    function validateStep2() {
        return worldHighStreetTermsAccepted && venueTermsAccepted !== false;
    }





    function matchValue(v1, v2) {
        return v1 === v2;
    }

    // Step navigation
    const nextStep = () => {
        if (currentStep === 0 && !validateStep1()) return;
        if (currentStep === 1 && !validateStep2()) {
            setError('Please accept both terms and conditions to continue');
            return;
        }
        
        setError('');
        
        // After T&Cs acceptance, create the user account
        if (currentStep === 1) {
            handleCreateAccount();
            return;
        }
        
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        } else {
            handleFinalSubmit();
        }
    };

    const prevStep = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
            setError('');
            
            // Reset user exists flag when going back to allow retry
            if (currentStep === 2) {
                setUserAlreadyExists(false);
            }
            
            // Reload subscriptions when going back from subscription step to T&Cs
        }
    };

    // Handle account creation after T&Cs acceptance
    const handleCreateAccount = async () => {
        setError("");
        setLoading(true);

        const accountData = {
            OiriginTrace: oiriginTrace,
            VenueKey: venueKey,
            EmailAddress: formData.email,
            FirstName: formData.firstName,
            Surname: formData.surname,
            Password: formData.password,
            WorldHighStreetTermsAccepted: worldHighStreetTermsAccepted,
            VenueTermsAccepted: venueTermsAccepted
        };

        try {
            const response = await fetch(`${baseUrl}/api/users/signup`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(accountData)
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Account created successfully:', data);
                
                // Store the user ID
                setUserId(data.userId || data.id); // Adjust based on your API response structure
                setUserAlreadyExists(false); // Reset the flag
                
                // Go directly to completion step
                setCurrentStep(2); // Go to completion step
            } else {
                const errorData = await response.json();
                
                // Check if user already exists
                if (errorData.code === "user_already_exists") {
                    console.log('User already exists, continuing...');
                    setUserAlreadyExists(true);
                    
                    // Extract user ID from error response if available
                    if (errorData.userId) {
                        console.log('Extracted user ID from error response:', userId);
                        setUserId(errorData.userId);
                    }
                    
                    // Go directly to completion step
                    setCurrentStep(2); // Go to completion step
                } else {
                    throw new Error(errorData.message || 'Failed to create account');
                }
            }
        } catch (error) {
            console.error('Error:', error);
            setError('Failed to create account. Please try again.');
        } finally {
            setLoading(false);
        }
    };


    // Handle final account creation
    const handleFinalSubmit = async () => {
        navigate('/activate-account');
    };



    return (
        <div className="min-h-screen bg-black flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl w-full space-y-8">
                <div className="text-center">
                    <h2 className="text-3xl font-bold text-white mb-2">Create Account</h2>
                    <p className="text-gray-400">Join the World's High Street community</p>
                </div>

                <AccountSetupStepper currentStep={currentStep} />
                
                {error && (
                    <div className="bg-gray-900 border border-gray-700 text-red-300 px-4 py-3 rounded-lg">
                        {error}
                    </div>
                )}

                <div className="card p-8">
                    <div className="mb-6">
                        <h3 className="text-lg font-semibold text-white mb-2">
                            Step {currentStep + 1} of {steps.length}: {steps[currentStep]}
                        </h3>
                        <div className="w-full bg-gray-800 rounded-full h-2">
                            <div 
                                className="bg-gray-600 h-2 rounded-full transition-all duration-300"
                                style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
                            />
                        </div>
                    </div>

                    {/* Render current step */}
                    {currentStep === 0 && (
                        <AccountDetailsStep
                            formData={formData}
                            setFormData={setFormData}
                            venueKey={venueKey}
                            emailValidationText={emailValidationText}
                            passwordValidationText={passwordValidationText}
                        />
                    )}
                    {currentStep === 1 && (
                        <TermsStep
                            worldHighStreetTermsAccepted={worldHighStreetTermsAccepted}
                            setWorldHighStreetTermsAccepted={setWorldHighStreetTermsAccepted}
                            venueTermsAccepted={venueTermsAccepted}
                            setVenueTermsAccepted={setVenueTermsAccepted}
                            venueKey={venueKey}
                        />
                    )}
                    {/* Show completion step */}
                    {currentStep === 2 && (
                        <AccountCompletionStep
                            userAlreadyExists={userAlreadyExists}
                        />
                    )}

                    {/* Navigation buttons */}
                    <div className="flex justify-between mt-8">
                        <button
                            type="button"
                            onClick={prevStep}
                            disabled={currentStep === 0}
                            className={`flex items-center px-4 py-2 rounded-lg font-medium transition-colors ${
                                currentStep === 0
                                    ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
                                    : 'bg-gray-600 text-white hover:bg-gray-500'
                            }`}
                        >
                            <ArrowLeftIcon className="h-4 w-4 mr-2" />
                            Previous
                        </button>

                        <button
                            type="button"
                            onClick={nextStep}
                            disabled={loading}
                            className="flex items-center btn-primary"
                        >
                            {loading ? (
                                <>
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                    {currentStep === 1 ? (userAlreadyExists ? 'Continuing...' : 'Creating Account...') : 'Loading...'}
                                </>
                            ) : currentStep === 1 ? (
                                <>
                                    <CheckIcon className="h-4 w-4 mr-2" />
                                    {userAlreadyExists ? 'Continue' : 'Create Account'}
                                </>
                            ) : currentStep === steps.length - 1 ? (
                                <>
                                    <CheckIcon className="h-4 w-4 mr-2" />
                                    Complete
                                </>
                            ) : (
                                <>
                                    Next
                                    <ArrowRightIcon className="h-4 w-4 ml-2" />
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateAccount;
